module.exports = __webpack_public_path__ + "img/V-L-1-unload-connect.6f04fdde.png";